var google_analytics_ready;

google_analytics_ready = function () {
  if (window.ga != null) {
    ga("set", "location", location.href.split("#")[0]);
    return ga("send", "pageview", {
      title: document.title,
    });
  }
};

$(document).ready(google_analytics_ready);

$(document).on("page:change", google_analytics_ready);

// ---
// generated by coffee-script 1.9.2
